import React from 'react';
import { Link } from "gatsby"
import './../style.css';
import logo from './../images/logo.jpg';

export default function Layout({ children }) {
    return (
        <>
            <div id="wrapper">
                <div id="middle">
                <div id="left">
                <img src={logo} alt="Fietsen Marijnissen" width="143" height="428" /><br />
                </div>
                <div id="right">
                    <div id="menu">
                        <ul>
                            <li><Link to="/">home</Link></li>
                            <li><Link to="/locatie">locatie</Link></li>
                            <li><Link to="/contact">contact</Link></li>
                        </ul>
                    </div>
                    {children}
                </div>
                <div id="clear"></div>
                </div>

                <div id="foot">
                &nbsp;
                </div>
                <div id="copy"><p>&copy; Fietsen Marijnissen | <Link to="/disclaimer">Disclaimer</Link> | <Link to="/privacy">Privacy Statement</Link></p></div>
            </div>
        </>
    )
  };
